import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { SharedStoreEffects } from '@core-lib/store/shared-store/effects';
import { sharedStoreReducer } from '@core-lib/store/shared-store/reducer';
import { FeatureName } from '@core-lib/store/shared-store/feature';

@NgModule({
	imports: [CommonModule, StoreModule.forFeature(FeatureName, sharedStoreReducer), EffectsModule.forFeature([SharedStoreEffects])]
})
export class SharedStoreModule {}
